<template>
  <div
    v-if="!cookiesConsent"
    class="fixed bottom-0 top-0 left-0 right-0 z-50 flex justify-center w-full  bg-black/50 px-3"
  >
    <div
      class="fixed top-[80vh] flex flex-wrap items-center justify-between w-[95%] px-5 py-4 mx-auto bg-white rounded-xl xl:w-[65%] shadow-xl "
    >
      <p>
        This website uses cookies to improve your experience. <NuxtLink
          href="/cookies"
          class="text-primary"
        >Learn more</NuxtLink>
      </p>
      <div class="flex flex-wrap gap-3 py-2">
        <!-- <button
          class="inline-flex items-center justify-center px-6 py-2 tracking-wide text-gray-400 uppercase duration-200 rounded-full lg:px-8 shadow-base hover:shadow-lg hover:-translate-y-1 will-change-transform group"
          @click="declineCookies">Decline</button> -->
        <ButtonBasic

          @click="acceptCookies"
        >
          Accept
        </ButtonBasic>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const cookiesConsent = useCookie<'accepted' | 'declined' | undefined>('consent', undefined)

function acceptCookies() {
  cookiesConsent.value = 'accepted'
}
function declineCookies() {
  cookiesConsent.value = 'declined'
}

const agreedToCookiesScriptConsent = useScriptTriggerConsent()

watch(cookiesConsent, (newVal) => {
  if (newVal === 'accepted') {
    agreedToCookiesScriptConsent.accept()
  }
})

useScriptGoogleAnalytics({
  scriptOptions: {
    trigger: agreedToCookiesScriptConsent,
  },
})
</script>
